module.exports = __webpack_public_path__ + "media/flags/md-3c40de43.svg";